<template>
    <section class="container payment">
        <el-card v-if="!payment_done">
            <el-button @click="showCheckout">Go Back</el-button>

            <h2 class="text-center" v-show="show_text">
                <span>Fetching payment details.....</span>
            </h2>
            <section class="payment-container">
                <form id="payment-form">
                    <div id="card-element"></div>
                    <div id="card-errors" role="alert"></div>
                    <el-button v-loading.fullscreen.lock="loading" v-if="show_btn" class="stripe-btn" round
                               @click.prevent="submitForm">
                        <i class="el-icon-goods"></i> Pay now
                    </el-button>
                    <div class="text-center mt-15" v-else>
                        <p class="help-text">Please don't reload or close the page..we are processing your payment request..</p>
                        <i class="el-icon-loading"></i>
                    </div>
                </form>
            </section>
        </el-card>
        <el-card v-else>
            <section class="p-15">
                <el-alert :type="payment.type" :title="payment.message" close-text="Close"></el-alert>
                <p class="text-center">You will be re-directed in 5 sec..</p>
                <p class="text-center mt-10">
                    <router-link class="orders-btn" :to="{ name: 'my-orders'}">View Orders</router-link>
                </p>
            </section>
        </el-card>

    </section>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "MakePayment",
        data() {
            return {
                stripe: '',
                card: '',
                elements: '',
                show_btn: false,
                loading: false,
                error: false,
                show_text: true,
                payment_done: false,
                payment: {
                    type: '',
                    message: ''
                }
            }
        },
        computed: {
            ...mapGetters('errors', ['getMessage', 'getErrors']),
            ...mapGetters('payments', ['getStripe']),
            ...mapGetters('orders', ['getOrder']),
            ...mapGetters('auth', ['getAuthenticatedUser']),
        },
        mounted() {
            if (this.getStripe) {
                this.configureStripe();
            } else {
                this.error = true
            }
        },
        methods: {
            showCheckout() {
                this.$emit('checkout:show');
            },
            configureStripe() {
                // eslint-disable-next-line no-undef
                this.stripe = Stripe(this.getStripe.key);
                this.elements = this.stripe.elements();
                this.card = this.elements.create('card');
                this.card.mount('#card-element');
                this.show_text = false;
                this.show_btn = true;
            },
            submitForm() {
                const _vm = this;
                _vm.show_btn = false;
                this.stripe.confirmCardPayment(this.getStripe.intent, {
                    payment_method: {
                        card: this.card,
                        billing_details: {
                            name: this.getAuthenticatedUser.name,
                            email: this.getAuthenticatedUser.email,
                        }
                    }
                }).then(async function (result) {
                    if (result.error) {
                        _vm.show_btn = true;
                        // Show error to your customer (e.g., insufficient funds)
                        await _vm.$store.dispatch('payments/store', {
                            order: _vm.getOrder,
                            payment: result.error,
                            error: result.error
                        })
                        if (_vm.getMessage) {
                            _vm.payment_done = true;
                            _vm.payment.type = 'error';
                            _vm.payment.message = _vm.getMessage
                            await _vm.$store.dispatch('checkout/clearCheckout');
                        }
                    } else {
                        // The payment has been processed!
                        if (result.paymentIntent.status === 'succeeded') {
                            await _vm.$store.dispatch('payments/store', {
                                order: _vm.getOrder,
                                payment: result.paymentIntent
                            })
                            if (_vm.getMessage) {
                                _vm.payment_done = true;
                                _vm.payment.type = 'success';
                                _vm.payment.message = _vm.getMessage
                                await _vm.$store.dispatch('checkout/clearCheckout');
                                setTimeout(() => {
                                    _vm.$router.push({name: 'my-orders'})
                                }, 5000)
                            }
                        }
                    }
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .payment {
        .stripe-btn {
            background: #fff;
            color: #333;
            padding: 12px 20px;
            display: block;
            width: 100%;
            transition: all .2s linear;
            border-color: #bdbdbd;
            margin-top: 25px;
            margin-bottom: 15px;
            font-size: .9rem;

            span {
                color: #fff;
            }

            &:hover {
                background: #ececec;
                color: #333;

                span {
                    color: black;
                }
            }
        }

        .payment-container {
            padding: 50px 20px;
            display: flex;
            width: 50%;
            margin: 0 auto;

            #payment-form {
                width: 100%;
            }
        }
    }

    .StripeElement {
        box-sizing: border-box;
        height: 40px;
        padding: 10px 12px;
        border: 1px solid transparent;
        border-radius: 4px;
        background-color: #ececec;
        box-shadow: 0 1px 3px 0 #e6ebf1;
        -webkit-transition: box-shadow 150ms ease;
        transition: box-shadow 150ms ease;
    }

    .StripeElement--focus {
        box-shadow: 0 1px 3px 0 #cfd7df;
    }

    .StripeElement--invalid {
        border-color: #fa755a;
    }

    .StripeElement--webkit-autofill {
        background-color: #fefde5 !important;
    }

    .el-alert {
        .el-alert__title {
            font-size: 1.5rem;
        }
    }
    .orders-btn {
        padding: 10px 25px;
        border: 1px solid #efeefe;
        border-radius: 5px;
        background: white;
        color: #000;
        font-size: .9rem;
        margin: 0 auto;
        display: inline-block;
    }
    .help-text {
        color: #11233f;
        font-weight: bold;
        font-size: .95rem;
    }
</style>
